<script setup>
  import { ref } from "vue";
  import OrderByAsc from "./OrderByAsc.vue";
  import OrderAlf from "./OrderAlf.vue";
  import OrderSeries from "./OrderSeries.vue";

  const props = defineProps({
    sortFilters: {
      type: Object,
      default: null,
    }
  });

  const emit = defineEmits(['update:sortOrder']);
  const localSortFilters = ref(props.sortFilters);


  const emitActiveSortOrder = (value, type) => {
    emit('update:sortOrder', { value, type });
  };
</script>

<template>
  <div class="filters-container">
    <div class="order-by-asc-wrapper">
      <order-by-asc
        :sorts="localSortFilters.number"
        @update:sortOrder="(value) => emitActiveSortOrder(value, 'number')"
      ></order-by-asc>
    </div>

    <div class="order-alf-wrapper">
      <order-alf
        :sorts="localSortFilters.name"
        @update:sortOrder="(value) => emitActiveSortOrder(value, 'name')"
      ></order-alf>
    </div>

    <div class="order-series-wrapper">
      <order-series
        :sorts="localSortFilters.series"
        @update:sortOrder="(value) => emitActiveSortOrder(value, 'series')"
      ></order-series>
    </div>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

</style>
